import { makeStyles } from '@mui/styles';
import { Container, Grid, Typography } from '@mui/material';
import FlowChartHowItWorkStepContent from './FlowChartHowItWorkStepContent';
import FlowChartHowItWorkStepTitle from './FlowChartHowItWorkStepTitle';

const useStyles = makeStyles((theme) => ({
  FlowChartHowItWorkStepsBg: {
    display: 'block',
    paddingTop: '85px',
    paddingBottom: '50px',
  },
  FlowChartHowItWorkStepsBox: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingBottom: '52px',

    '& span': {
      fontWeight: 'bold',
      fontSize: '24px',
      lineHeight: 1,
      color: '#fff',
      backgroundColor: '#008B5E',
      borderRadius: '50%',
      alignItems: 'end',
      width: '40px',
      height: '40px',
      textAlign: 'center',
      padding: '8px 0px',
      marginRight: '35px',
    },
  },

  FlowChartHowItWorkStepsContent: {
    display: 'block',
    width: 'calc(100% - 150px)',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 76px)',
    },

    '& h2': {
      fontWeight: 'bold',
      fontSize: '20px',
      lineHeight: '24px',
      color: '#111111',
      paddingBottom: '8px',
    },

    '& p': {
      fontSize: '16px',
      fontWeight: 'normal',
      lineHeight: '30px',
      color: '#111111',
    },
  },
}));

export default function FlowChartHowItWorkSteps({ StepJson }) {
  const classes = useStyles();
  return (
    <section className={classes.FlowChartHowItWorkStepsBg}>
      <Container>
        <Grid item xs={12}>
          {/* TODO: fix key */}
          {StepJson &&
            StepJson.map((item, i) => {
              return (
                <div
                  key={i}
                  className={classes.FlowChartHowItWorkStepsBox}
                  id={item.id}
                >
                  <Typography variant="body1" component="span">
                    {item.index}
                  </Typography>
                  <div className={classes.FlowChartHowItWorkStepsContent}>
                    <FlowChartHowItWorkStepTitle title={item.title} />
                    <FlowChartHowItWorkStepContent content={item.content} />
                  </div>
                </div>
              );
            })}
        </Grid>
      </Container>
    </section>
  );
}
